import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { CostTypeDialogComponent } from './cost-type-dialog.component';

export * from './cost-type-dialog.component';
@NgModule({
    declarations: [ CostTypeDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        TranslateModule,
    ],
})
export class CostTypeDialogModule {
}
